import { ActivatedRoute } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { SidenavService } from 'src/app/services/sidenav.service';
import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.scss']
})
export class CompanyViewComponent implements OnInit {

  constructor(private sideNavService:SidenavService,private appStateSrv:AppStateProvider,private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    const customUrl=`/company/company-view/${this.activatedRoute.snapshot.params.id}`
    const route = this.sideNavService.routingChunks({name: 'Company', customUrl:customUrl});
    this.appStateSrv.setSideNavState(route);
  }

  blockedContact: boolean = false;
  verified: boolean =false;
  notVerified: boolean = true;
  enableInvite: any;

  toggleSelection(event) {
    this.enableInvite = !this.enableInvite;
  }

}
